<nb-actions size="small">
  <nb-action *ngrxLet="inProgress$ as inProgress">
    @if (!inProgress) {
      <button type="button" nbButton status="info" (click)="startTracking()">
        <nb-icon icon="clock-outline"></nb-icon>
        Start Timer
      </button>
    }
    @if (inProgress) {
      <button type="button" nbButton status="warning" (click)="stopTracking()">
        <nb-icon icon="clock-outline"></nb-icon>
        Switch / Stop {{ timer$ | async }}
      </button>
    }
  </nb-action>
</nb-actions>
